export const ConsumerProfileAssetOverviewStyles = {
  container: 'flex justify-center w-full',
  submitButton: 'text-xl sm:text-2xl mb-8 mt-24',
}
